import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { APP_ENVIRONMENT } from "config";
import {
  klaviyoFormSchema,
  get_cookie,
  setSubscribeDataAsPerLocation,
  getSubscribeDataAsPerLocation,
} from "utils";
import { useFormik } from "formik";
import { klaviyoSubscribe } from "store/actions";

const KlaviyoOffer = ({ currentLocationId }) => {
  const dispatch = useDispatch();

  const isLoggedUser = useSelector((state) => state?.user?.token);
  const [isWeb, setIsWeb] = useState(true);
  const [successMsg, setSuccessMsg] = useState(false);
  const [showOfferPopup, setShowOfferPopup] = useState(false);
  const myInputRef = useRef();

  /*******************
  @purpose : Append klayviyo script and check device is web or mobile
  @Author : INIC
  ******************/
  useEffect(() => {
    if (window.screen.width < 768) {
      setIsWeb(false);
    } else {
      setIsWeb(true);
    }
    setShowOfferPopup(getSubscribeDataAsPerLocation());
  }, [get_cookie("cityStateSlug")]);

  /*******************
  @purpose : Klaviyo screen attach
  @Author : INIC
  ******************/
  useEffect(() => {
    if (APP_ENVIRONMENT === "production" && !isLoggedUser) {
      const script = document.createElement("script");
      script.src =
        "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=TNzeBN";
      script.async = true;
      document.body.appendChild(script);
    }
  }, [isLoggedUser]);

  /*******************
  @purpose : Subscribe handler for email marketing
  @Author : INIC
  ******************/
  const subscribeHandler = () => {
    let showLa = "yes";

    if (get_cookie("cityStateSlug")) {
      if (get_cookie("cityStateSlug").includes("la")) {
        showLa = "yes";
      } else {
        showLa = "";
      }
    }
    if (showLa) {
      // For LA:
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", "VFtapu"]);
    } else {
      // For Miami:
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", "TwUePB"]);
    }
  };

  /*******************
  @Purpose : Formik, submit 
  @Parameter : {}
  @Author : INIC
  *******************/
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    enableReinitialize: true,
    validationSchema: klaviyoFormSchema,
    onSubmit: async (values1) => {
      const data = {
        subscriber_email: values1.email,
        location_id: currentLocationId,
      };

      dispatch(klaviyoSubscribe(data))
        .then(() => {
          setSuccessMsg(true);
          formik.resetForm();

          setTimeout(() => {
            setSubscribeDataAsPerLocation();
            setShowOfferPopup(false);
          }, 2000);
        })
        .catch(() => {
          formik.resetForm();
        });
    },
  });

  useEffect(() => {
    formik?.errors?.email ? myInputRef.current.focus() : "";
  }, [formik.errors]);

  /*******************
@Purpose : Formik Properties
@Parameter : {}
@Author : INIC
*******************/
  const { errors, handleSubmit, touched } = formik;

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <Fragment>
      {APP_ENVIRONMENT === "production" &&
      // here instead of false it was => JSON.parse(process.env.NEXT_PUBLIC_KLEVIYO_SUB_BTN_DISPLAY)
        !isLoggedUser && false && (
          <Button
            variant="primary"
            type="button"
            className={`w-100 font-16 ff-hel-med  mb-3 ${
              isWeb ? "mt-0" : "mt-3"
            }`}
            onClick={subscribeHandler}
          >
            Subscribe
          </Button>
        )}

      {/* {!isLoggedUser && showOfferPopup && (
        <div className="get-in-touch subscription-form mb-3">
          <h3 className="mb-0 ff-hel-med">
            Special offers & latest additions!
          </h3>
          <Form className="form-inline mt-3" onSubmit={handleSubmit}>
            <div className="input-field form-group mb-0 w-100">
              <div className="floating-form">
                <Form.Group
                  controlId="formEmail"
                  className="floating-form-group error"
                >
                  <Form.Control
                    className={`${
                      formik?.touched["email"] &&
                      formik?.errors["email"] &&
                      "error"
                    }`}
                    formik={formik}
                    type="text"
                    ref={myInputRef}
                    name="email"
                    placeholder="Email"
                    value={formik.values.email}
                    onChange={(e) => {
                      formik.setFieldValue("email", e.target.value);
                    }}
                  />
                  <Form.Label className="floating-label p-0">
                    Email *
                  </Form.Label>
                  {touched?.email && errors.email && (
                    <span className="text-danger text-error error-msg">
                      {errors.email}
                    </span>
                  )}

                  {successMsg && (
                    <span className="text-success text-error error-msg">
                      {successMsg
                        ? VALIDATIONS_ERROR_MESSAGES.KLAVIYO_SUCCESS
                        : ""}
                    </span>
                  )}
                </Form.Group>
              </div>
              <div className="ml-sm-2">
                <Button
                  variant="primary"
                  type="submit"
                  className={`w-100 font-16 ff-hel-med mb-0 mt-3 mt-sm-0`}
                >
                  Subscribe
                </Button>
              </div>
            </div>
          </Form>
        </div>
      )} */}
    </Fragment>
  );
};

export default KlaviyoOffer;
